import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-almacen-insumos',
  templateUrl: './almacen-insumos.component.html',
  styleUrls: ['./almacen-insumos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlmacenInsumosComponent {
  constructor() {}
}
